import { blocklyStore } from './../blocklyStore';
import { DialogHandler } from '../../components/dialog/DialogHandler';
import { AbstractBlock } from '../AbstractBlock';
import { blocklyDispatcher } from '../blocklyDispatcher';

export class SketchFabDialogButton extends AbstractBlock {
  constructor(title) {
    super('', '');
    this.title = title;
    // ワークスペースをマウントしたときにイベントをハンドリング
    blocklyDispatcher.addMountedWorkspaceListener(function (workspace) {
      workspace.registerButtonCallback('click_sketchfab_show', () => {
        blocklyStore.save();
        DialogHandler.showSketchFabAuthDialog();
      });
      blocklyDispatcher.triggerUpdateToolbox(workspace);
    });
  }

  toXml() {
    const el = document.createElement('button');
    el.setAttribute('text', this.title);
    el.setAttribute('callbackKey', 'click_sketchfab_show');
    el.setAttribute('web-class', 'poly_button');
    return el;
    // return  '<button text="グーグルPolyを開く" callbackKey="click_poly_show"></button>'
  }
}
